var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBottomnavPackage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_awesome-box"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M192.01,214.09H57.67c-10.43,0-18.92-8.5-18.93-18.93V114.24H210.94v80.93c0,10.43-8.5,18.92-18.93,18.93ZM45.61,121.1v74.07c0,6.65,5.42,12.06,12.07,12.07H192.01c6.65,0,12.07-5.42,12.08-12.07V121.1H45.61Zm165.18-10.33H126.58V41.91h49.12c8.15,0,15.35,5.2,17.92,12.94l16.42,49.28c.24,.97,.4,1.96,.48,2.96l.27,3.68Zm-77.34-6.86h69.3l-15.64-46.89c-1.63-4.94-6.22-8.24-11.41-8.24h-42.26v55.14Zm-10.34,6.86H38.88l.29-3.7c.08-1,.24-1.99,.49-2.96l16.41-49.27c2.57-7.74,9.76-12.93,17.92-12.93h49.11V110.76Zm-76.15-6.86H116.24V48.77h-42.25c-5.2,0-9.78,3.31-11.42,8.24l-15.63,46.9Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomnavPackage);
export default __webpack_public_path__ + "static/media/bottomnav-package.89a93f008fe5acdd4b28eecfa84d9bd9.svg";
export { ForwardRef as ReactComponent };